'use client'

import { useState } from 'react'
import Head from 'next/head'
import {
  HydrationBoundary,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import logWrapper from '@/utils/logWrapper'
import PaymentMethods from '@/components/billing/PaymentMethods'
import BillingCycle from '@/components/billing/BillingCycle'
import PaymentMethod from '@/components/billing/PaymentMethod'
import CurrentPeriod from '@/components/billing/CurrentPeriod'
import NextPeriod from '@/components/billing/NextPeriod'
import PaymentHistory from '@/components/billing/PaymentHistory'

const Billing = () => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error) => {
            const errorTyped = error
            if (errorTyped) {
              logWrapper(`Something went wrong: ${errorTyped.message}`)
            }
          },
        }),
      }),
  )
  const dehydratedState = undefined

  return (
    <>
      <Head>
        <title>Billing</title>
        <meta name="description" content="Billing" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div>
        <QueryClientProvider client={queryClient}>
          <HydrationBoundary state={dehydratedState}>
            <PaymentMethods />
            <BillingCycle />
            <PaymentMethod />
            <div className="grid grid-cols-2">
              <CurrentPeriod />
              <NextPeriod />
            </div>
            <PaymentHistory />
          </HydrationBoundary>
          <ReactQueryDevtools initialIsOpen />
        </QueryClientProvider>
      </div>
    </>
  )
}

export default Billing
